var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emap-flow-toolbar" },
    [
      _c("footer-buttons", {
        attrs: { buttons: _vm.buttons, "limit-more": _vm.limitMore },
        on: { "btn-click": _vm.btnClick },
      }),
      _vm._v(" "),
      _vm.cur_btn.commandType === "changeAssignee"
        ? _c("change-assignee", {
            attrs: {
              options: _vm.cur_btn,
              taskid: _vm.taskid,
              defkey: _vm.defkey,
            },
            on: { "on-confirm": _vm.changeAssigneeConfirm },
            model: {
              value: _vm.changeAssigneePopup,
              callback: function ($$v) {
                _vm.changeAssigneePopup = $$v
              },
              expression: "changeAssigneePopup",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.buttonsId.indexOf("processStatus") > -1
        ? _c("emap-flow-steps-m", {
            attrs: {
              defkey: _vm.defkey,
              taskid: _vm.taskid,
              options: _vm.process_status,
            },
            model: {
              value: _vm.processStatusPopup,
              callback: function ($$v) {
                _vm.processStatusPopup = $$v
              },
              expression: "processStatusPopup",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.buttonsId.indexOf("urgent") > -1
        ? _c(
            "van-popup",
            {
              style: { width: "100%" },
              attrs: { position: "bottom", "get-container": "body" },
              model: {
                value: _vm.urgentPopup,
                callback: function ($$v) {
                  _vm.urgentPopup = $$v
                },
                expression: "urgentPopup",
              },
            },
            [
              _c(
                "van-form",
                { ref: "urgent", on: { submit: _vm.urgentConfirm } },
                [
                  _c("van-field", {
                    attrs: {
                      name: "content",
                      label: _vm.urgentLabel.contentText,
                      placeholder: "请输入",
                      required: "",
                      maxlength: "500",
                      type: "textarea",
                      "show-word-limit": "",
                      rules: [{ required: true, message: "请填写催办内容" }],
                    },
                    model: {
                      value: _vm.urgentForm.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.urgentForm, "content", $$v)
                      },
                      expression: "urgentForm.content",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "van-field",
                    {
                      attrs: {
                        name: "sendType",
                        label: _vm.urgentLabel.typeText,
                        required: "",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "input" },
                        [
                          _c(
                            "van-checkbox-group",
                            {
                              attrs: { direction: "horizontal" },
                              model: {
                                value: _vm.urgentForm.sendType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.urgentForm, "sendType", $$v)
                                },
                                expression: "urgentForm.sendType",
                              },
                            },
                            _vm._l(_vm.sendType, function (item, index) {
                              return _c(
                                "van-checkbox",
                                {
                                  key: index,
                                  attrs: { name: item.id, shape: "square" },
                                },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "van-row",
                    [
                      _c(
                        "van-col",
                        { attrs: { span: "12" } },
                        [
                          _c(
                            "van-button",
                            {
                              attrs: { block: "", square: "" },
                              on: {
                                click: function ($event) {
                                  _vm.urgentPopup = false
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.cancelText))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { attrs: { span: "12" } },
                        [
                          _c(
                            "van-button",
                            {
                              attrs: {
                                type: "info",
                                block: "",
                                square: "",
                                "native-type": "submit",
                              },
                            },
                            [_vm._v(_vm._s(_vm.confirmText))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.cur_btn.commandType === "addAssigneeTask"
        ? _c("add-assignee", {
            attrs: { taskid: _vm.taskid, defkey: _vm.defkey },
            on: { "on-confirm": _vm.addAssigneeConfirm },
            model: {
              value: _vm.addAssigneePopup,
              callback: function ($$v) {
                _vm.addAssigneePopup = $$v
              },
              expression: "addAssigneePopup",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.cur_btn.commandType === "deleteAssigneeTask"
        ? _c("del-assignee", {
            attrs: { taskid: _vm.taskid, defkey: _vm.defkey },
            on: { "on-confirm": _vm.delAssigneeConfirm },
            model: {
              value: _vm.delAssigneePopup,
              callback: function ($$v) {
                _vm.delAssigneePopup = $$v
              },
              expression: "delAssigneePopup",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.buttonsId.indexOf("processTrack") > -1
        ? _c(
            "van-popup",
            {
              style: { width: "100%", height: "100%" },
              attrs: { position: "bottom", "get-container": "body" },
              model: {
                value: _vm.processTrackPopup,
                callback: function ($$v) {
                  _vm.processTrackPopup = $$v
                },
                expression: "processTrackPopup",
              },
            },
            [
              _c("div", { staticClass: "process-track-container" }, [
                _c(
                  "div",
                  {
                    ref: "js-canvas",
                    staticStyle: {
                      position: "relative",
                      height: "100%",
                      "padding-top": "20px",
                    },
                    attrs: { id: "js-canvas" },
                  },
                  [
                    _c("span", { staticClass: "process-track-nodata" }, [
                      _vm._v("获取流程轨迹失败！"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "van-button",
                {
                  attrs: { type: "info", block: "", square: "" },
                  on: {
                    click: function ($event) {
                      _vm.processTrackPopup = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.confirmText))]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.buttonsId.indexOf("turnback") > -1
        ? _c(
            "van-action-sheet",
            {
              attrs: { title: "退回", "get-container": "body" },
              model: {
                value: _vm.backModal,
                callback: function ($$v) {
                  _vm.backModal = $$v
                },
                expression: "backModal",
              },
            },
            [
              _c("emap-flow-next-step-m", {
                ref: "nextstep",
                attrs: {
                  taskId: _vm.taskid,
                  nodeurl: _vm.turnbackObj[_vm.cur_btn.backTo + "Node"],
                  assigneeurl: _vm.turnbackObj[_vm.cur_btn.backTo + "Assignee"],
                  schema: "simple",
                  showNextNode: "",
                  echostyle: "id",
                  nodelabel: _vm.turnbackObj.nodelabel,
                  assigneeslabel: _vm.turnbackObj.assigneeslabel,
                  onnodeverify: _vm.turnbackNodeResponse,
                },
                model: {
                  value: _vm.turnbackValue,
                  callback: function ($$v) {
                    _vm.turnbackValue = $$v
                  },
                  expression: "turnbackValue",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "back-footer" },
                [
                  _c(
                    "van-button",
                    {
                      attrs: { type: "info", block: "", round: "" },
                      on: { click: _vm.backConfirm },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }